module.exports = __webpack_public_path__ + "img/logo-loading.c6c91f4fee20ecd5841168a861812637.svg";